import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-sidebar-trigger',
    templateUrl: './sidebar-trigger.component.html',
    styleUrls: ['./sidebar-trigger.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SidebarTriggerComponent {
    @Input() isOpen: boolean;
    @Input() mobileMode = false;
    @Output() isOpenChange = new EventEmitter<boolean>();

    readonly viewBoxSize = 30;
    readonly menuLineStroke = 4.5;
    readonly menuLineMargin = 3;
    readonly crossLineStroke = 1;
    readonly crossLinePadding = 3;

    get viewBox() {
        return `0 0 ${this.viewBoxSize} ${this.viewBoxSize}`;
    }

    get menuTopPath() {
        const y = this.viewBoxSize / 2 - this.menuLineStroke - this.menuLineMargin;
        return `M 0 ${y} L ${this.viewBoxSize} ${y}`;
    }

    get menuMiddlePath() {
        const y = this.viewBoxSize / 2;
        return `M 0 ${y} L ${this.viewBoxSize} ${y}`;
    }

    get menuBottomPath() {
        const y = this.viewBoxSize / 2 + this.menuLineStroke + this.menuLineMargin;
        return `M 0 ${y} L ${this.viewBoxSize} ${y}`;
    }

    get crossTopPath() {
        const start = this.crossLinePadding;
        const end = this.viewBoxSize - this.crossLinePadding;
        return `M ${start} ${start} L ${end} ${end}`;
    }

    get crossMiddlePath() {
        const y = this.viewBoxSize / 2;
        return `M ${this.crossLinePadding} ${y} L ${this.crossLinePadding} ${y}`;
    }

    get crossBottomPath() {
        const start = this.crossLinePadding;
        const end = this.viewBoxSize - this.crossLinePadding;
        return `M ${start} ${end} L ${end} ${start}`;
    }

    get isCross() {
        return this.mobileMode && this.isOpen;
    }

    onClick() {
        if (this.mobileMode) {
            this.isOpenChange.emit(!this.isOpen);
        } else {
            this.isOpenChange.emit(true);
        }
    }

    onMouseEnter() {
        if (!this.mobileMode) {
            this.isOpenChange.emit(true);
        }
    }

    onMouseLeave() {
        if (!this.mobileMode) {
            this.isOpenChange.emit(false);
        }
    }
}
